<div class="layout-root">
  <app-sidebar class="sidebar"></app-sidebar>
  <div class="main-content">
    <app-header class="fixed-header"></app-header>
    <div class="content-area">
      <ng-content></ng-content>
    </div>
  </div>
</div>
